<div class="card-div">
    <div class="card">
        <div class="card-header">
            <div class="card-header-text">{{ title }}</div>
        </div>
        <div class="card-content">
            <div class="card-content-header">{{ mainTextHeader }}</div>
            <div class="card-content-body">{{ mainTextBody }}</div>
            <div class="card-content-footer" (click)="callToActionClickHandler()">{{ callToActionText }}</div>
        </div>
    </div>
</div>
